<template>
  <div class="feature-card">
    <div class="card-header">
      <p class="card-title">{{ title }}</p>
      <VSwitch
        connotation="cta"
        :modelValue="localEnabled"
        @update:modelValue="(val) => { if (!readonly) localEnabled = val; }"
        :class="{ 'switch-readonly': readonly }"
      />
    </div>
    <div class="card-content">
      <p>{{ description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "FeatureCard",
  props: {
    title: { type: String, required: true },
    description: { type: String, required: true },
    enabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
  },
  emits: ["update:enabled"],

  data() {
    return {
      localEnabled: this.enabled,
    };
  },

  watch: {
    localEnabled(newValue) {
      this.$emit("update:enabled", newValue);
    },
    enabled(newValue) {
      this.localEnabled = newValue;
    },
  },
};
</script>

<style scoped>
.feature-card {
  border-radius: 12px;
  border: 1px solid var(--background-primary);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  padding: 16px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  background-color: #fff;
  width: 100%;
}

.feature-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--black);
  margin: 0;
}

.card-content p {
  font-size: 14px;
  color: var(--gray-04);
  line-height: 1.4;
  margin-top: 8px;
  margin-bottom: 0;
}
</style>

<style>
/* Keep purple color on readonly VSwitch */
.feature-card .switch-readonly {
  pointer-events: none;
  opacity: 0.6;
}
</style>
